module.exports = __WEBPACK_EXTERNAL_MODULE_2__;


/*****************
 ** WEBPACK FOOTER
 ** external {"commonjs":"react","commonjs2":"react","amd":"React","root":"React"}
 ** module id = 2
 ** module chunks = 0
 **/